<template>
    <div class="flex gap-1 w-full">
        <div class="bg-white col-span-1">
            <select @change="updatePhone()" v-model="countryCode" :class="textTheme" class="py-6 px-5 appearance-none" name="" id="">
                <option v-for="country in countries" :key="country.code" :value="country.dial_code" class="px-3"><p class=" mr-2">{{ country.emoji }}</p> {{ country.dial_code }}</option>
            </select>
        </div>
        <div class="bg-white w-full">
            <input v-model="phone" @input="updatePhone()" type="number" :class="textTheme" class="w-full p-6" autocomplete="phone">
        </div>
    </div>
</template>

<script setup lang="ts">
    import countries from '../../assets/country_codes.json';
    const countryCode = ref('+45');
    const phone = ref('');
    const route = ref('test');

    const emit = defineEmits(["update:modelValue"]);

    onMounted(() => {
        route.value = window.location.origin;
    })

    function updatePhone() {
        emit("update:modelValue", {
            phone: countryCode.value + phone.value
        });
    };

    const textTheme = computed(() => {
        if (route.value.includes('nordvaerk')) {
            return 'text-primary'
        } else if (route.value.includes('bibliotek')) {
            return 'text-bib'
        } else {
            return 'text-primary'
        }
    });
</script>

<style>
input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
}

/* Firefox */
input[type=number] {
    -moz-appearance: textfield;
}
</style>